var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card"},[(_vm.getBatteryLoadingById || !_vm.batteryIsLoaded)?_c('loading'):(!_vm.hasAuthorize.getById)?_c('no-auth'):_c('div',[_c('battery-features',{attrs:{"form":_vm.batteryItem}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }